import { useTheme } from "../../hooks/useTheme";

export function AppearanceSection() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="settings-section">
      <p className="settings-eyebrow">Appearance</p>
      <p className="settings-desc">Customize the look and feel</p>

      <div className="form-group">
        <label className="label" htmlFor="pref-theme">Theme</label>
        <select
          id="pref-theme"
          className="input"
          value={theme}
          onChange={(e) => setTheme(e.target.value as "light" | "dark" | "system")}
        >
          <option value="system">System</option>
          <option value="light">Light</option>
          <option value="dark">Dark</option>
        </select>
      </div>
    </div>
  );
}
